<div>
    <forge-page-state>
        <img *ngIf="isServerError" slot="graphic" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/500-error-spot-hero.svg" alt="Image of a broken down car.">

        <img *ngIf="isNotFoundError" slot="graphic" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/404-error-spot-hero.svg" alt="An illustration of a cactus, the sun, and another cactus forming the number 404.">

        <img *ngIf="isPermissionError" slot="graphic" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/403-error-spot-hero.svg" alt="Illustration of a UFO flying away from Area 51.">

        <div slot="title">{{errorHeader}}</div>

        <div slot="message">{{errorMessage}}</div>
    </forge-page-state>
</div>